
export const FlashOfferAPI = {
  flashoffer: {
    list: '/real_estate/flash_offers',
    create: '/real_estate/flash_offers',
    real_estate: '/real_estate',
    by_broker: '/brokers/:id/customer_services',
    detail: '/real_estate/flash_offers/:id',
    update: '/real_estate/flash_offers/:id',
    stop: '/real_estate/flash_offers/stop',
    flash_offer_item: '/real_estate/flash_offers/items',
    result: '/real_estate/flash_offers/items'
  }
}


